import { Request, Response } from "express"

import { getPreheat, putPreheat } from "#services/recipe/preheat"

export const getRecipePreheat = async (req: Request, res: Response) => {
	const list = await getPreheat({
		id: req.params.recipeID,
	})

	res.json(list)
}

export const updateRecipePreheat = async (req: Request, res: Response) => {
	const results = await putPreheat(req.body)

	if (results.error && results.error.errno && results.error.errno > 0) {
		res.status(500).send(results)
	} else {
		res.send(req.body)
	}
}
